import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Clock,
  Search,
  Film,
  Brain,
  User,
  Database,
  ChevronDown,
  ChevronUp,
  Tag
} from 'lucide-react';

// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
// ReviewGate
// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4} />
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
// PatternList â€" market_research pattern arrays
// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
const PatternList = ({ title, items = [] }) => {
  if (!items.length) return null;
  return (
    <div>
      <p className="text-xs font-semibold text-blue-600 uppercase tracking-wide mb-1">{title}</p>
      <ul className="space-y-1">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-gray-700">
            <span className="text-blue-400 mt-0.5">â€¢</span>
            <span>{typeof item === "string" ? item : JSON.stringify(item)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
// MarketResearchCard â€" collapsible
// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
const MarketResearchCard = ({ research = {} }) => {
  const [expanded, setExpanded] = useState(false);
  if (!research || !Object.keys(research).length) return null;

  const patterns = [
    { key: 'recurring_stop_scrolling_hooks', label: 'Stop-Scrolling Hooks' },
    { key: 'recurring_hooks', label: 'Recurring Hooks' },
    { key: 'recurring_cta', label: 'Recurring CTA' },
    { key: 'recurring_visuals', label: 'Recurring Visuals' },
    { key: 'recurring_proof_mechanisms', label: 'Proof Mechanisms' },
    { key: 'attention_patterns', label: 'Attention Patterns' },
    { key: 'trust_patterns', label: 'Trust Patterns' },
    { key: 'desire_patterns', label: 'Desire Patterns' },
    { key: 'risk_reduction_patterns', label: 'Risk Reduction' },
    { key: 'platform_language_patterns', label: 'Platform Language' },
    { key: 'market_observations', label: 'Market Observations' },
    { key: 'ugc_patterns', label: 'UGC Patterns' },
    { key: 'competitor_patterns', label: 'Competitor Patterns' },
    { key: 'recurring_persuasion_recognition_patterns', label: 'Persuasion Recognition' },
    { key: 'recurring_commercial_intent_patterns', label: 'Commercial Intent Detection' },
    { key: 'recurring_manipulation_detection_patterns', label: 'Manipulation Detection' },
    { key: 'recurring_strategic_selection_patterns', label: 'Strategic Selection' },
    { key: 'recurring_credibility_discount_patterns', label: 'Credibility Discount' },
    { key: 'recurring_autonomy_preservation_patterns', label: 'Autonomy Preservation' },
    { key: 'recurring_verification_behaviors', label: 'Verification Behaviors' },
    { key: 'recurring_evidence_independence_patterns', label: 'Evidence Independence' },
    { key: 'higher_order_observations', label: 'Higher-Order Observations' },
  ];

  const visiblePatterns = expanded ? patterns : patterns.slice(0, 4);

  return (
    <div className="rounded-lg border border-blue-200 overflow-hidden">
      <div className="flex items-center gap-2 p-3 bg-blue-50">
        <Search className="w-4 h-4 text-blue-700" />
        <span className="text-xs font-semibold text-blue-700 uppercase tracking-wide">Market Research</span>
        <span className="text-xs text-blue-500">(pattern ricorrenti)</span>
        <span className="ml-auto text-xs text-gray-400">{patterns.length} categorie</span>
      </div>
      <div className="bg-white p-4 space-y-3">
        {visiblePatterns.map(({ key, label }) => (
          <PatternList key={key} title={label} items={research[key]} />
        ))}
        <button onClick={() => setExpanded(!expanded)}
          className="flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 mt-2">
          {expanded ? <><ChevronUp className="w-3 h-3" /> Mostra meno</> : <><ChevronDown className="w-3 h-3" /> Mostra tutti i pattern</>}
        </button>
      </div>
    </div>
  );
};

// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
// WinningContentCard â€" collapsible content item
// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
const WinningContentCard = ({ item = {}, index }) => {
  const [expanded, setExpanded] = useState(false);
  const hook = item.stop_scrolling_hook || {};
  const first3 = item.first_3_seconds || {};
  const visual = item.visual_style || {};
  const product = item.product_presence || {};
  const higherOrder = item.higher_order_observation || {};

  return (
    <div className="rounded-lg border border-gray-200 overflow-hidden">
      <button onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left">
        <div className="flex items-center gap-3">
          <span className="w-7 h-7 flex items-center justify-center rounded-full bg-blue-100 text-blue-700 text-xs font-bold flex-shrink-0">
            {index + 1}
          </span>
          <div>
            <p className="text-sm font-medium text-gray-800">{item.content_reference || `Content Pattern ${index + 1}`}</p>
            <div className="flex gap-2 mt-0.5">
              {item.platform && <span className="text-xs text-gray-500">{item.platform}</span>}
              {item.hook_type && <span className="px-1.5 py-0.5 text-xs bg-blue-100 text-blue-700 rounded">{item.hook_type}</span>}
            </div>
          </div>
        </div>
        {expanded ? <ChevronUp className="w-4 h-4 text-gray-400 flex-shrink-0" /> : <ChevronDown className="w-4 h-4 text-gray-400 flex-shrink-0" />}
      </button>

      {expanded && (
        <div className="p-4 space-y-3 bg-white border-t border-gray-100">
          {/* Stop Scrolling Hook */}
          {Object.keys(hook).length > 0 && (
            <div className="bg-amber-50 rounded p-3">
              <p className="text-xs font-semibold text-amber-700 uppercase tracking-wide mb-2">Stop-Scrolling Hook</p>
              <div className="grid grid-cols-2 gap-2">
                {Object.entries(hook).map(([k, v]) => (
                  <div key={k}>
                    <span className="text-xs text-amber-600">{k.replace(/_/g, ' ')}: </span>
                    <span className="text-xs text-gray-700">{v}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* First 3 Seconds */}
          {(first3.spoken_text || (first3.visual_events && first3.visual_events.length > 0)) && (
            <div>
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">First 3 Seconds</p>
              {first3.spoken_text && <p className="text-sm text-gray-700"><span className="font-medium">Speech: </span>{first3.spoken_text}</p>}
              {first3.on_screen_text && <p className="text-sm text-gray-700"><span className="font-medium">Text: </span>{first3.on_screen_text}</p>}
              {first3.visual_events && first3.visual_events.length > 0 && (
                <ul className="mt-1 space-y-0.5">
                  {first3.visual_events.map((e, i) => <li key={i} className="text-sm text-gray-600">â€¢ {e}</li>)}
                </ul>
              )}
            </div>
          )}

          {/* Narrative Arc */}
          {item.narrative_arc && item.narrative_arc.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">Narrative Arc</p>
              <ol className="space-y-1">
                {item.narrative_arc.map((step, i) => (
                  <li key={i} className="flex gap-2 text-sm text-gray-700">
                    <span className="text-gray-400 flex-shrink-0">{i + 1}.</span>
                    {step}
                  </li>
                ))}
              </ol>
            </div>
          )}

          {/* Emotional Triggers */}
          {item.emotional_triggers && item.emotional_triggers.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-1">Emotional Triggers</p>
              <div className="flex flex-wrap gap-1">
                {item.emotional_triggers.map((t, i) => (
                  <span key={i} className="px-2 py-0.5 bg-pink-100 text-pink-700 text-xs rounded-full">{t}</span>
                ))}
              </div>
            </div>
          )}

          {/* Visual Style */}
          {Object.keys(visual).length > 0 && (
            <div className="bg-gray-50 rounded p-3">
              <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">Visual Style</p>
              <div className="grid grid-cols-2 gap-1">
                {Object.entries(visual).map(([k, v]) => (
                  <div key={k} className="text-xs">
                    <span className="text-gray-500">{k.replace(/_/g, ' ')}: </span>
                    <span className="text-gray-700">{v}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Root Cause */}
          {item.root_cause_analysis && (
            <div className="bg-green-50 rounded p-3">
              <p className="text-xs font-semibold text-green-700 uppercase tracking-wide mb-1">Root Cause Analysis</p>
              <p className="text-sm text-gray-700 leading-relaxed">{item.root_cause_analysis}</p>
            </div>
          )}

          {/* Higher-Order Observation (Step 8) */}
          {Object.keys(higherOrder).length > 0 && (
            <div className="bg-violet-50 rounded p-3 border border-violet-100">
              <p className="text-xs font-semibold text-violet-700 uppercase tracking-wide mb-2">Higher-Order Inference (Step 8)</p>
              <div className="space-y-1.5">
                {higherOrder.observable_communicative_intention && (
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-violet-500 shrink-0">Intent:</span>
                    <span className="text-xs font-medium text-violet-800">{higherOrder.observable_communicative_intention}</span>
                  </div>
                )}
                <div className="flex gap-3">
                  {higherOrder.persuasion_visibility && (
                    <span className={`px-1.5 py-0.5 text-xs rounded ${higherOrder.persuasion_visibility === 'low' ? 'bg-green-100 text-green-700' : higherOrder.persuasion_visibility === 'high' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'}`}>
                      Persuasion: {higherOrder.persuasion_visibility}
                    </span>
                  )}
                  {higherOrder.commercial_visibility && (
                    <span className={`px-1.5 py-0.5 text-xs rounded ${higherOrder.commercial_visibility === 'low' ? 'bg-green-100 text-green-700' : higherOrder.commercial_visibility === 'high' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'}`}>
                      Commercial: {higherOrder.commercial_visibility}
                    </span>
                  )}
                </div>
                {higherOrder.orchestration_signals?.length > 0 && (
                  <div>
                    <span className="text-xs text-violet-500">Orchestration signals: </span>
                    <span className="text-xs text-gray-700">{higherOrder.orchestration_signals.join(' · ')}</span>
                  </div>
                )}
                {higherOrder.higher_order_robustness && (
                  <div>
                    <span className="text-xs text-violet-500">Robustness: </span>
                    <span className="text-xs text-gray-700">{higherOrder.higher_order_robustness}</span>
                  </div>
                )}
                {higherOrder.autonomy_preservation && (
                  <div>
                    <span className="text-xs text-violet-500">Autonomy: </span>
                    <span className="text-xs text-gray-700">{higherOrder.autonomy_preservation}</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
// LanguageModelCard
// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
const LanguageModelCard = ({ model = {} }) => {
  const [expanded, setExpanded] = useState(true);
  if (!model || !Object.keys(model).length) return null;

  const fieldLabels = {
    creator_style: 'Creator Style',
    visual_style: 'Visual Style',
    environment_style: 'Environment Style',
    speech_style: 'Speech Style',
    editing_style: 'Editing Style',
    persuasion_style: 'Persuasion Style',
    ugc_authenticity_rules: 'UGC Authenticity Rules',
    forbidden_patterns: 'Forbidden Patterns'
  };

  return (
    <div className="rounded-lg border border-purple-200 overflow-hidden">
      <button onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-3 bg-purple-50 hover:bg-purple-100 transition-colors">
        <div className="flex items-center gap-2">
          <Brain className="w-4 h-4 text-purple-700" />
          <span className="text-xs font-semibold text-purple-700 uppercase tracking-wide">Market Language Model</span>
        </div>
        {expanded ? <ChevronUp className="w-4 h-4 text-purple-400" /> : <ChevronDown className="w-4 h-4 text-purple-400" />}
      </button>
      {expanded && (
        <div className="bg-white p-4 space-y-3 border-t border-purple-100">
          {Object.entries(model).map(([key, value]) => (
            <div key={key}>
              <p className="text-xs font-semibold text-purple-600 uppercase tracking-wide mb-1">
                {fieldLabels[key] || key.replace(/_/g, ' ')}
              </p>
              {Array.isArray(value) ? (
                <ul className="space-y-0.5">
                  {value.map((item, i) => (
                    <li key={i} className="flex items-start gap-1.5 text-sm text-gray-700">
                      <span className="text-purple-300 mt-0.5">â€¢</span>
                      {typeof item === 'string' ? item : JSON.stringify(item)}
                    </li>
                  ))}
                </ul>
              ) : typeof value === 'object' ? (
                <div className="grid grid-cols-2 gap-1">
                  {Object.entries(value).map(([k, v]) => (
                    <div key={k} className="text-xs">
                      <span className="text-gray-500">{k.replace(/_/g, ' ')}: </span>
                      <span className="text-gray-700">{typeof v === 'string' ? v : JSON.stringify(v)}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-700 leading-relaxed">{String(value)}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
// CreatorModelCard
// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
const CreatorModelCard = ({ model = {} }) => {
  const [expanded, setExpanded] = useState(false);
  if (!model || !Object.keys(model).length) return null;

  return (
    <div className="rounded-lg border border-teal-200 overflow-hidden">
      <button onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-3 bg-teal-50 hover:bg-teal-100 transition-colors">
        <div className="flex items-center gap-2">
          <User className="w-4 h-4 text-teal-700" />
          <span className="text-xs font-semibold text-teal-700 uppercase tracking-wide">Creator Model</span>
          <span className="text-xs text-teal-500">(dominant profile)</span>
        </div>
        {expanded ? <ChevronUp className="w-4 h-4 text-teal-400" /> : <ChevronDown className="w-4 h-4 text-teal-400" />}
      </button>
      {expanded && (
        <div className="bg-white p-4 space-y-2 border-t border-teal-100">
          {Object.entries(model).map(([key, value]) => (
            <div key={key}>
              <span className="text-xs font-semibold text-teal-600 capitalize">{key.replace(/_/g, ' ')}: </span>
              {Array.isArray(value) ? (
                <span className="text-sm text-gray-700">{value.join(' Â· ')}</span>
              ) : (
                <span className="text-sm text-gray-700">{String(value)}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const HigherOrderMarketModelCard = ({ model = {} }) => {
  const [expanded, setExpanded] = useState(false);
  if (!model || !Object.keys(model).length) return null;

  const sections = [
    { key: 'second_order_prior_observations', label: 'Second-Order Prior Observations', color: 'text-violet-600' },
    { key: 'communicative_intention_observations', label: 'Communicative Intention Observations', color: 'text-violet-600' },
    { key: 'persuasion_recognition_triggers', label: 'Persuasion Recognition Triggers', color: 'text-orange-600' },
    { key: 'commercial_intent_triggers', label: 'Commercial Intent Triggers', color: 'text-orange-600' },
    { key: 'manipulation_detection_triggers', label: 'Manipulation Detection Triggers', color: 'text-red-600' },
    { key: 'strategic_selection_triggers', label: 'Strategic Selection Triggers', color: 'text-red-600' },
    { key: 'credibility_discount_triggers', label: 'Credibility Discount Triggers', color: 'text-red-600' },
    { key: 'autonomy_protection_patterns', label: 'Autonomy Protection Patterns', color: 'text-green-600' },
    { key: 'verification_preferences', label: 'Verification Preferences', color: 'text-green-600' },
    { key: 'evidence_independence_patterns', label: 'Evidence Independence Patterns', color: 'text-green-600' },
    { key: 'higher_order_robustness_patterns', label: 'Higher-Order Robustness Patterns', color: 'text-blue-600' },
  ];

  return (
    <div className="rounded-lg border border-violet-200 overflow-hidden">
      <button onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-3 bg-violet-50 hover:bg-violet-100 transition-colors">
        <div className="flex items-center gap-2">
          <Brain className="w-4 h-4 text-violet-700" />
          <span className="text-xs font-semibold text-violet-700 uppercase tracking-wide">Higher-Order Market Model</span>
        </div>
        {expanded ? <ChevronUp className="w-4 h-4 text-violet-400" /> : <ChevronDown className="w-4 h-4 text-violet-400" />}
      </button>
      {expanded && (
        <div className="bg-white p-4 space-y-3 border-t border-violet-100">
          {sections.map(({ key, label, color }) => {
            const items = model[key];
            if (!items?.length) return null;
            return (
              <div key={key}>
                <p className={`text-xs font-semibold ${color} uppercase tracking-wide mb-1`}>{label}</p>
                <ul className="space-y-0.5">
                  {items.map((item, i) => (
                    <li key={i} className="flex items-start gap-1.5 text-sm text-gray-700">
                      <span className="text-violet-300 mt-0.5">•</span>
                      {typeof item === 'string' ? item : JSON.stringify(item)}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const RetrievalMetadataCard = ({ meta = {} }) => {
  if (!meta || !Object.keys(meta).length) return null;
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
      <div className="flex items-center gap-2 mb-2">
        <Database className="w-4 h-4 text-gray-500" />
        <span className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Retrieval Metadata</span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {meta.coverage_ratio && (
          <div className="text-xs"><span className="text-gray-500">Coverage: </span><span className="text-gray-700">{meta.coverage_ratio}</span></div>
        )}
        {meta.retrieval_capability && (
          <div className="text-xs"><span className="text-gray-500">Mode: </span><span className="text-gray-700">{meta.retrieval_capability}</span></div>
        )}
      </div>
      {meta.limitations && meta.limitations.length > 0 && (
        <div className="mt-2">
          <span className="text-xs text-gray-500">Limitations: </span>
          <span className="text-xs text-gray-700">{meta.limitations.join(', ')}</span>
        </div>
      )}
    </div>
  );
};

// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
// EmptyState
// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
const EmptyState = () => (
  <div className="flex items-center justify-center h-full">
    <div className="text-center text-gray-500">
      <Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" />
      <p className="text-lg font-medium mb-2">In attesa di esecuzione</p>
      <p className="text-sm">Clicca "Esegui Contract" per avviare il Market Research Engine</p>
    </div>
  </div>
);

// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
// Contract01View
// â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€
const Contract01View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution) return <EmptyState />;

  const output = execution.output || execution.outputData || {};
  const research = output.market_research || {};
  const library = output.winning_content_library || [];
  const langModel = output.market_language_model || {};
  const creatorModel = output.creator_model || {};
  const higherOrderModel = output.higher_order_market_model || {};
  const retrieval = output.retrieval_metadata || {};

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="max-w-4xl mx-auto space-y-6">

        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-1">
            <Search className="w-6 h-6 text-blue-600" />
            <h2 className="text-xl font-bold text-gray-800">Market Research</h2>
            <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-700 rounded-full font-medium">C01</span>
          </div>
          <p className="text-sm text-gray-500">Ricerca UGC e analisi pattern â€" libreria contenuti vincenti e modello linguistico del mercato</p>

          {/* Stats */}
          <div className="flex gap-4 mt-3">
            <div className="bg-blue-50 rounded-lg px-3 py-2 text-center">
              <p className="text-xl font-bold text-blue-700">{library.length}</p>
              <p className="text-xs text-blue-500">Winning Content</p>
            </div>
            <div className="bg-purple-50 rounded-lg px-3 py-2 text-center">
              <p className="text-xl font-bold text-purple-700">{Object.keys(research).filter(k => Array.isArray(research[k]) && research[k].length > 0).length}</p>
              <p className="text-xs text-purple-500">Pattern Categories</p>
            </div>
            <div className="bg-teal-50 rounded-lg px-3 py-2 text-center">
              <p className="text-xl font-bold text-teal-700">{retrieval.retrieval_capability || 'N/A'}</p>
              <p className="text-xs text-teal-500">Retrieval Mode</p>
            </div>
          </div>
        </div>

        {/* Market Research Patterns */}
        <MarketResearchCard research={research} />

        {/* Winning Content Library */}
        {library.length > 0 && (
          <div className="rounded-lg border border-amber-200 overflow-hidden">
            <div className="flex items-center gap-2 p-3 bg-amber-50">
              <Film className="w-4 h-4 text-amber-700" />
              <span className="text-xs font-semibold text-amber-700 uppercase tracking-wide">Winning Content Library</span>
              <span className="ml-auto text-xs text-gray-400">{library.length} patterns</span>
            </div>
            <div className="bg-white p-3 space-y-2">
              {library.map((item, i) => (
                <WinningContentCard key={i} item={item} index={i} />
              ))}
            </div>
          </div>
        )}

        {/* Market Language Model */}
        <LanguageModelCard model={langModel} />

        {/* Creator Model */}
        <CreatorModelCard model={creatorModel} />

        {/* Higher-Order Market Model */}
        <HigherOrderMarketModelCard model={higherOrderModel} />

        {/* Retrieval Metadata */}
        <RetrievalMetadataCard meta={retrieval} />

        {/* Review Gate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Contract01View;

